<template>
  <div
    class="cursor-pointer bg-gray-400 inline-flex overflow-hidden"
    :class="[radiusClass]"
    @click="handleImageClick"
  >
    <img :src="proxiedUrl" class="h-full w-full" loading="lazy" alt="" />
  </div>
</template>

<script>
import { computed } from 'vue'
import { openImageViewer } from '@/utils/events'

export default {
  props: {
    url: {
      type: String,
      default: ''
    },
    openUrl: {
      type: String,
      default: null
    },
    w: {
      type: [String, Number],
      default: 100
    },
    h: {
      type: [String, Number],
      default: null
    },
    fit: {
      type: String,
      default: 'cover',
      validator: val => ['contain', 'cover'].includes(val)
    },
    radiusClass: {
      type: String,
      default: 'rounded-xl'
    },
  },
  setup (props) {
    const proxiedUrl = computed(() => {
      const url = new URL(props.url)
      const height = props.h ?? props.w

      url.searchParams.append('output', 'webp')
      url.searchParams.append('q', 90)
      url.searchParams.append('w', props.w)
      url.searchParams.append('h', height)
      url.searchParams.append('fit', props.fit)

      return url.toString()
    })

    function handleImageClick () {
      if (props.openUrl) {
        window.open(props.openUrl, '_blank')
        return
      }

      function convertToWebp(link) {
        const url = new URL(link)
        url.searchParams.append('output', 'webp')
        return url.toString()
      }

      const url = props.url.endsWith('.heic')
        ? convertToWebp(props.url)
        : props.url

      openImageViewer([url])
    }

    return {
      proxiedUrl,
      handleImageClick
    }
  }
}
</script>
